import styled, { withTheme } from 'styled-components'
import { rem } from 'polished'
import { Truncate } from '../../../utils/style'

const ColumnDescription = styled(Truncate)`
  font-size: ${rem(14)};
`

export default withTheme(ColumnDescription)
